import $ from 'jquery';

( function( $ ) {
	var addCustomFileInput = function($field){
		var $input = $field.find('input[type="file"]');
		var $flag = $field.find('.file-input').length;

		if (($input.length) && !$flag){
			$field.addClass('gf-fileupload');

			var $label = $('<label></label>').attr('for', $input.attr('id'));
			$label.addClass('file-input');

			$('<span class="file-input__info">No file selected</span>').appendTo($label);
			$('<span class="file-input__cta">Browse</span>').appendTo($label);
			$input.after($label);

			$input.on('change', function(e){
				var fileName = '';

				if (this.files && this.files.length > 1) {
					fileName = ( this.getAttribute( 'data-multiple-caption' ) || '' ).replace( '{count}', this.files.length );
				} else if( e.target.value ) {
					fileName = e.target.value.split( '\\' ).pop();
				}

				if (fileName) {
					var fileNameTruncated = fileName.length > 10 ? '... ' + fileName.substr( fileName.length - 12 ) : fileName;
					$field.find('.file-input__info').html(fileNameTruncated);
				} else {
					$field.find('.file-input__info').html('No file selected');
				}
			});
		}
	};

	// AppendTo Button
	var appendButtonToGformFields = function($button){
		var $flag = $button.parent('.gfield').length;
		if( !$flag ){
			$button.appendTo($('.c-form .gform_fields')).wrap('<li class="gfield gfield--auto"></li>');
		}

	};


	// Trigger on GF form render
	jQuery(document).on('gform_post_render', function(){
		$('.js-file-input').each(function(){
			addCustomFileInput($(this));
		});
		$('.c-form .gform_button').each(function(){
			appendButtonToGformFields($(this));
		});
	});
} ( jQuery ) );